import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "./CommonInterfaces";
import {DosyaBorcluEgmMahrumiyetCevap} from "@/plugins/uyap-plugin/uyap/DosyaBorcluEgmMahrumiyet";
import {indexOf} from "lodash";

export interface DosyaBorcluEgmTalep {
    dosyaId: string | number,
    kisiKurumId: number,
    sorguBakiye: number | string,
    pageIndex: 0
}

export interface DosyaBorcluEgmCevap extends ISorguSonuc<IDosyaBorcluEgmSonuc>{
}

export interface IDosyaBorcluEgmSonuc {
    aracBilgileri: AracBilgileri,
    borcluBilgileri: BorcluBilgileri,
    aracSayisi?: number,
}

export interface AracBilgileri {
    // Ortak alanlar
    hataMesaj?: string,
    hatakod?: number,
    kurumAdi?: string,
    kurumTipi?: number,
    sonuc?: string,
    
    // Normal başarılı yanıt (kişi/kurum - araç var)
    aracList?: Array<IArac>,
    aracSayisi?: number,
    isMock?: boolean,
    
    // Kurum için hata yanıtı (araç yok)
    data?: Array<{
        calintiDurumu?: number,
        aracDurumu?: number,
        trfMenDurumu?: number,
        plakaCalintiDurumu?: number,
        hataMesaj?: string,
        hatakod?: number,
        isNew?: boolean
    }>,
    metadata?: {
        FMTY?: string,
        FMTE?: string,
        FMC?: string
    },
    isNew?: boolean
}

export interface IArac {
    cins: string,
    isMock: boolean,
    marka: string,
    model: string,
    plaka: string,
    plakaSifreli: string,
    renk: string,
    ticariAd: string,
    selected: boolean,
    mahrumiyet: DosyaBorcluEgmMahrumiyetCevap|null,
    hacizSerhi: number
}

export interface BorcluBilgileri {
    kisiKurumId: number,
    kisiTumDVO?: KisiTumDVO,
    kurumDVO?: KurumDVO
    turu: number
}

export interface KisiTumDVO {
    adi: string,
    aktifMernisAdresiSorgusu: boolean,
    anaAdi: string,
    babaAdi: string,
    dogumTarihiStr: string,
    hasOlumKaydi: boolean,
    isAvukat: boolean,
    isHakimSavci: boolean,
    isNoter: boolean,
    isTarafUyari: boolean,
    mernisDegisiklikNedeni: string,
    mernisDegisiklikVarmi: boolean,
    olumKaydi: boolean,
    sorguTuru: number,
    soyadi: string,
    tcKimlikNo: string,
}

export interface KurumDVO {
    kurumAdi: string
    vergiNo: string
    veriGelisYeri: number
    faaliyetDurumu: number
    tacirMi: string
    mersisIlKodu: number
    mersisIlceKodu: number
}

export default class DosyaBorcluEgm extends UyapRequest<DosyaBorcluEgmTalep, DosyaBorcluEgmCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "Dosya borçlu EGM bilgileri sorgulanıyor...";
    }


    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "Borclu_EGM_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","yabanci":false,"mavikart":false,"sorguTuru":0,"tcKimlikNo":"3********60","adi":"İS****","soyadi":"YÜ*****","babaAdi":"M*******","anaAdi":"N******","dogumTarihiStr":"1979","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":36147192,"turu":0},"sorgulayanBilgileri":"Av.NİHAN ERDOĞAN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 7. Genel İcra Dairesi","birimId":"1000942","orgKodu":"1.04.011.000.6042","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6042","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2023/41114","dosyaNoYil":2023,"dosyaSira":41114,"dosyaId":"eWsgTfrDdgdIFWAq1QTXMv5z3mMG91JQKWtKx0BcIVr+BbAlIZxOyYaDPs1CTP5a","dosyaAcilisTarihi":"04/11/2023 20:32","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"BAHADIR BİRSÖZ, İSMAİL YÜCEDAĞ, YDS ACADEMY ÖZEL YABANCI DİL EĞİTİM LİMİTED ŞİRKETİ, GÜZEL ÇELİK","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false,"adet":0},"sorguTarihi":"06/02/2026 10:52","sorguSonucDVO":{"aracBilgileri":{"aracList":[{"plaka":"06***51","marka":"FIAT","model":"1992","ticariAd":"TEMPRA","renk":"GRİ","cins":"OTOMOBİL","plakaSifreli":"LQvKS2@ssTYC6MVtJa4sKg==","isMock":false}],"aracSayisi":1,"isMock":false},"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","yabanci":false,"mavikart":false,"sorguTuru":0,"tcKimlikNo":"3********60","adi":"İS****","soyadi":"YÜ*****","babaAdi":"M*******","anaAdi":"N******","dogumTarihiStr":"1979","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":36147192,"turu":0}},"sorgulamaTuru":"EGM Sorgu","sorguSonucu":false,"hasError":false,"hasData":false,"isMock":false}
        //     sorgu başarılı - kurum - kayıt yok
        //     return {"borcluBilgileri":{"kisiKurumId":245274099,"kurumDVO":{"kurumAdi":" KA**** DE**** ME***** SA**** VE Tİ***** Lİ***** Şİ*****","vergiNo":"4981782423","veriGelisYeri":0,"faaliyetDurumu":-1,"tacirMi":"H","mersisIlKodu":0,"mersisIlceKodu":0},"turu":1},"sorgulayanBilgileri":"Av.HÜSEYİN GÜLTEKİN DURĞUN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 7. Genel İcra Dairesi","birimId":"1000942","orgKodu":"1.04.011.000.6042","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6042","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2024/12337","dosyaNoYil":2024,"dosyaSira":12337,"dosyaId":"3eecwdDzC9LeE5JJ@NpS@hlIatgIc7lu9umDIutnQDUc8o90fgQw4QLmLmDu9d+F","dosyaAcilisTarihi":"16/02/2024 17:13","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"TG TUNA GROUP DIŞ TİCARET MEDİKAL BİLİŞİM TEKSTİL İNŞAAT PROJE TAAHHÜT LİMİTED ŞİRKETİ, KAPLAN DENTAL MEDİKAL SANAYİ VE TİCARET LİMİTED ŞİRKETİ","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false,"adet":0},"sorguTarihi":"04/02/2026 01:09","sorguSonucDVO":{"aracBilgileri":{"data":[{"calintiDurumu":0,"aracDurumu":0,"trfMenDurumu":0,"plakaCalintiDurumu":0,"hataMesaj":"Girilen Kriterlere uygun Kayıt Bulunamadı.","hatakod":1,"isNew":true}],"metadata":{"FMTY":"SUCCESS","FMTE":"İşlem başarıyla gerçekleştirildi!","FMC":"ADALET_SUCCESS"},"isNew":true},"borcluBilgileri":{"kisiKurumId":245274099,"kurumDVO":{"kurumAdi":" KA**** DE**** ME***** SA**** VE Tİ***** Lİ***** Şİ*****","vergiNo":"4981782423","veriGelisYeri":0,"faaliyetDurumu":-1,"tacirMi":"H","mersisIlKodu":0,"mersisIlceKodu":0},"turu":1}},"sorgulamaTuru":"EGM Sorgu","sorguSonucu":false,"hasError":false,"hasData":false,"isMock":false}
        //     sorgu başarılı - kurum - kayıt var
        //     return {"borcluBilgileri":{"kisiKurumId":218696547,"kurumDVO":{"kurumAdi":" TG TU** GR*** DI* Tİ***** ME***** Bİ***** TE***** İN**** PR*** TA***** Lİ***** Şİ*****","vergiNo":"8620267233","veriGelisYeri":0,"faaliyetDurumu":-1,"tacirMi":"H","mersisIlKodu":0,"mersisIlceKodu":0},"turu":1},"sorgulayanBilgileri":"Av.HÜSEYİN GÜLTEKİN DURĞUN","portalTuru":2,"dosyaOzetDVO":{"birimDVO":{"birimAdi":"Ankara 7. Genel İcra Dairesi","birimId":"1000942","orgKodu":"1.04.011.000.6042","duzey1":"1","duzey2":"04","duzey3":"011","duzey4":"000","duzey5":"6042","birimTuru1":"11","birimTuru2":"1101","birimTuru3":"1199","evraginBirimDVODaGonderilecegiBirimBilgisi":0,"yeniBirimEkle":true,"orgKoduDegisti":false,"isTumunuKopyala":false,"eskiAd":"","eskiOrgKod":"","taranmamisKaydetme":"","testMi":0},"rolIdList":[],"isBirimKapali":false,"dosyaTurKod":35,"dosyaTurAd":"İcra Dosyası","dosyaNo":"2024/12337","dosyaNoYil":2024,"dosyaSira":12337,"dosyaId":"3eecwdDzC9LeE5JJ@NpS@vtLEphQIs+mtAmJfd8NPJrWJBUZSKUjtOwETYYww7uj","dosyaAcilisTarihi":"16/02/2024 17:13","genelDosyaDurumu":"Açık","genelDosyaDurumuAsInteger":0,"taraflar":"TG TUNA GROUP DIŞ TİCARET MEDİKAL BİLİŞİM TEKSTİL İNŞAAT PROJE TAAHHÜT LİMİTED ŞİRKETİ, KAPLAN DENTAL MEDİKAL SANAYİ VE TİCARET LİMİTED ŞİRKETİ","vekilId":0,"vekilMi":false,"vekilHazineAvukatiMi":false,"adet":0},"sorguTarihi":"04/02/2026 01:09","sorguSonucDVO":{"aracBilgileri":{"aracList":[{"plaka":"06****27","marka":"FORD","model":"2016","ticariAd":"Fiesta","renk":"BEYAZ","cins":"OTOMOBİL","plakaSifreli":"mD6Yxsy+MPcKlAkodSiylg\u003d\u003d","isMock":false}],"aracSayisi":1,"isMock":false},"borcluBilgileri":{"kisiKurumId":218696547,"kurumDVO":{"kurumAdi":" TG TU** GR*** DI* Tİ***** ME***** Bİ***** TE***** İN**** PR*** TA***** Lİ***** Şİ*****","vergiNo":"8620267233","veriGelisYeri":0,"faaliyetDurumu":-1,"tacirMi":"H","mersisIlKodu":0,"mersisIlceKodu":0},"turu":1}},"sorgulamaTuru":"EGM Sorgu","sorguSonucu":false,"hasError":false,"hasData":false,"isMock":false}
    }


    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_egm_brd.ajx';
    }

    async parse(data: any): Promise<DosyaBorcluEgmCevap> {
        if (typeof data.sorguSonucDVO != "undefined") {
            data.sorguSonucu = true;
            
            // Kurum için hata yanıtı kontrolü (data + metadata yapısı)
            if (typeof data.sorguSonucDVO.aracBilgileri.data != "undefined") {
                // Hata yanıtını normalize et
                data.sorguSonucDVO.aracBilgileri.aracList = [];
                data.sorguSonucDVO.aracBilgileri.aracSayisi = 0;
                
                // Hata mesajını metadata'dan veya data'dan al
                const errorData = data.sorguSonucDVO.aracBilgileri.data[0];
                if (errorData && errorData.hataMesaj) {
                    data.message = errorData.hataMesaj;
                } else if (data.sorguSonucDVO.aracBilgileri.metadata?.FMTE) {
                    data.message = data.sorguSonucDVO.aracBilgileri.metadata.FMTE;
                } else {
                    data.message = "Araç kaydı bulunamadı";
                }
            }
            // Normal başarılı yanıt kontrolü (aracList yapısı)
            else if (typeof data.sorguSonucDVO.aracBilgileri.aracList != "undefined") {
                // aracSayisi kontrolü ve varsayılan değer ataması
                if (typeof data.sorguSonucDVO.aracBilgileri.aracSayisi === "undefined") {
                    data.sorguSonucDVO.aracBilgileri.aracSayisi = data.sorguSonucDVO.aracBilgileri.aracList.length;
                }
                
                data.message = data.sorguSonucDVO.aracBilgileri.aracSayisi > 0 
                    ? `${data.sorguSonucDVO.aracBilgileri.aracSayisi} adet araç kaydı bulundu`
                    : "Araç kaydı bulunamadı";
                
                // Araç listesini hazırla
                data.sorguSonucDVO.aracBilgileri.aracList.forEach((arac: IArac) => {
                    arac.selected = true;
                    arac.mahrumiyet = null;
                    arac.hacizSerhi = 0;
                });
            }
            // Hiçbir yapı yoksa boş liste oluştur
            else {
                data.sorguSonucDVO.aracBilgileri.aracList = [];
                data.sorguSonucDVO.aracBilgileri.aracSayisi = 0;
                data.message = "Araç bilgisi alınamadı";
            }
            
            return data;
        }
        
        console.log("EGM PARSER Return ERROR message", data.message);
        throw new Error(data.message || "EGM sorgusunda hata oluştu");
    }
}

